var _toConsumableArray = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/2/Terralego/Customers/aguram-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _slicedToArray = require("/srv/nobackup/gitlabrunner/builds/JBHNUo9s/2/Terralego/Customers/aguram-deploy/visu-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

(function (a, b) {
  if ("function" == typeof define && define.amd) define(["exports", "@babel/runtime/helpers/objectWithoutProperties", "@babel/runtime/regenerator", "@babel/runtime/helpers/asyncToGenerator", "@babel/runtime/helpers/defineProperty", "@babel/runtime/helpers/slicedToArray", "./search", "../../Map/services/cluster"], b);else if ("undefined" != typeof exports) b(exports, require("@babel/runtime/helpers/objectWithoutProperties"), require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/asyncToGenerator"), require("@babel/runtime/helpers/defineProperty"), require("@babel/runtime/helpers/slicedToArray"), require("./search"), require("../../Map/services/cluster"));else {
    var c = {
      exports: {}
    };
    b(c.exports, a.objectWithoutProperties, a.regenerator, a.asyncToGenerator, a.defineProperty, a.slicedToArray, a.search, a.cluster), a.layersTreeUtils = c.exports;
  }
})("undefined" == typeof globalThis ? "undefined" == typeof self ? this : self : globalThis, function (a, b, c, d, e, f, g, h) {
  "use strict";

  function j(a, b) {
    var c = Object.keys(a);

    if (Object.getOwnPropertySymbols) {
      var d = Object.getOwnPropertySymbols(a);
      b && (d = d.filter(function (b) {
        return Object.getOwnPropertyDescriptor(a, b).enumerable;
      })), c.push.apply(c, d);
    }

    return c;
  }

  function k(a) {
    for (var b, c = 1; c < arguments.length; c++) {
      b = null == arguments[c] ? {} : arguments[c], c % 2 ? j(b, !0).forEach(function (c) {
        (0, e.default)(a, c, b[c]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : j(b).forEach(function (c) {
        Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
      });
    }

    return a;
  }

  function l(a, b, c) {
    var d = a.layers;
    var e = c;
    var f = Math.max(0, d.findIndex(function (_ref) {
      var a = _ref.default;
      return a;
    }));
    return d.forEach(function (a, c) {
      var d = k({}, b);
      d.active && c !== f && (d.active = !1), e = r(a, d, e);
    }), e;
  }
  /**
  * Compute new `newLayersTreeState` from `prevLayersTreeState`
  * with updated `layerState` for `layer`. If we want to `reset` state.
  * Do not update state.
  */


  var m = require("@babel/runtime/helpers/interopRequireWildcard"),
      n = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(a, "__esModule", {
    value: !0
  }), a.setGroupLayerStateAction = l, a.layersTreeStatesHaveChanged = function (a, b) {
    var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ["active"];
    return !c.reduce(function (c, d) {
      return c && Array.from(a).reduce(function (a, _ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            c = _ref3[0],
            _ref3$ = _ref3[1],
            e = _ref3$ === void 0 ? {} : _ref3$;

        return a && e[d] === (b.get(c) || {})[d];
      }, c);
    }, !0);
  }, a.default = a.layersTreeToStory = a.fetchPropertyRange = a.fetchPropertyValues = a.sortCustomLayers = a.resetFilters = a.filterFeatures = a.hasWidget = a.hasTable = a.filterLayersFromLayersState = a.filterLayersStatesFromLayersState = a.setLayerStateAction = a.initLayersStateAction = a.isCluster = a.INITIAL_FILTERS = void 0, b = n(b), c = n(c), d = n(d), e = n(e), f = n(f), g = m(g);
  var o = new Map();
  a.INITIAL_FILTERS = o;

  var p = function p(a, b) {
    return !!a.match(new RegExp("^".concat(b, "-").concat(h.PREFIX_SOURCE, "-[0-9]+")));
  };
  /**
  * Returns a flattened map of layers state from a layers tree
  *
  * @param {object} layersTree The layers tree config object
  * @param {string|string[]} layers Active layer(s) from hash
  * @param {string} table Active table from hash (layer id)
  * @return {Map} A reduced layer tree state
  */


  a.isCluster = p;

  var q = function q(a) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        b = _ref4.layers,
        c = _ref4.table;

    function d(a, e) {
      return a.reduce(function (a, e) {
        var g = e.initialState,
            h = void 0 === g ? {} : g,
            i = e.layers,
            j = void 0 === i ? [] : i,
            l = (0, f.default)(j, 1),
            m = l[0];
        return e.group ? d(e.layers, a) : (h.opacity = void 0 === h.opacity ? 1 : h.opacity, b && (h.active = Array.isArray(b) && b.includes(m) || b === m), c && c === m && (h.table = !0), a.set(e, k({
          active: !1,
          opacity: 1
        }, h)), a);
      }, e);
    }

    var e = new Map();
    return d(a, e);
  };

  a.initLayersStateAction = q;

  var r = function r(a, b, c, d) {
    if (a.group) return l(a, b, c);
    var e = new Map(c),
        f = e.get(a); // Clone layer current state

    if (!f) return c;
    var g = k({}, b);
    return g.table && e.forEach(function (a) {
      a.table = !1;
    }), e.set(a, k({}, d ? {} : f, {}, g)), e;
  };

  a.setLayerStateAction = r;

  var s = function s() {
    var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (_ref5) {
      var a = _ref5.active;
      return !!a;
    };
    return Array.from(a).reduce(function (a, _ref6) {
      var _ref7 = _slicedToArray(_ref6, 2),
          c = _ref7[0],
          d = _ref7[1];

      return b(d) ? [].concat(_toConsumableArray(a), [[c, d]]) : a;
    }, []);
  };

  a.filterLayersStatesFromLayersState = s;

  var t = function t(a, b) {
    return s(a, b).filter(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 1),
          _ref9$0$filters = _ref9[0].filters;

      _ref9$0$filters = _ref9$0$filters === void 0 ? {} : _ref9$0$filters;
      var a = _ref9$0$filters.layer;
      return a;
    }).map(function (_ref10) {
      var _ref11 = _slicedToArray(_ref10, 1),
          a = _ref11[0].filters.layer;

      return a;
    });
  };

  a.filterLayersFromLayersState = t;

  var u = function u(a) {
    return 0 < t(a, function (_ref12) {
      var a = _ref12.table;
      return a;
    }).length;
  };

  a.hasTable = u;

  var v = function v(a) {
    return 0 < s(a, function (_ref13) {
      var _ref13$widgets = _ref13.widgets,
          a = _ref13$widgets === void 0 ? [] : _ref13$widgets;
      return 0 < a.length;
    }).length;
  };

  a.hasWidget = v;

  var w = function w(a) {
    return Array.isArray(a) ? !!a.length && ["match", ["get", "_id"], a, !0, !1] : null;
  },
      x = function x(a, b
  /* = { id: { features: [id1, id2, …], layers [id1, id2,...] }} */
  , c) {
    Array.from(c).forEach(function (_ref14) {
      var _ref15 = _slicedToArray(_ref14, 2),
          _ref15$ = _ref15[0],
          c = _ref15$.layers,
          d = _ref15$.id,
          e = _ref15[1].active;

      if (!e || !c) return; // Keep only features ids for current layer id

      var f = b[d] || {},
          g = f.features;
      c.forEach(function (b) {
        var c = a.getLayer(b);

        if (c) {
          if (o.has(b) || o.set(b, a.getFilter(b)), !g) return void a.setFilter(b, o.get(b)); // Generate mapbox filter from id list

          var _c = w(g);

          a.setFilter(b, _c);
        }
      });
    });
  };

  a.filterFeatures = x;

  var y = function y(a, b) {
    Array.from(b).forEach(function (_ref16) {
      var _ref17 = _slicedToArray(_ref16, 1),
          _ref17$ = _ref17[0],
          _ref17$$layers = _ref17$.layers,
          c = _ref17$$layers === void 0 ? [] : _ref17$$layers,
          b = _ref17$.filters;

      b && c.forEach(function (b) {
        var c = a.getLayer(b);
        return a.getLayer(b) ? p(c.source, b) ? void a.fire("refreshCluster") : void (!o.has(b) || a.setFilter(b, o.get(b))) : void 0;
      });
    });
  };

  a.resetFilters = y;

  var z = function z(a) {
    return a.reduce(function (a, _ref18) {
      var b = _ref18.group,
          c = _ref18.layers;
      return [].concat(_toConsumableArray(a), _toConsumableArray(b ? z(c) : c));
    }, []);
  },
      A = function A(a, b) {
    var c = _toConsumableArray(a),
        d = z(b); // Reverse order as we want first layer come over next layer


    return d.forEach(function (a) {
      var b = c.findIndex(function (_ref19) {
        var b = _ref19.id;
        return b === a;
      });
      -1 < b && c.push.apply(c, _toConsumableArray(c.splice(b, 1)));
    }), c.reverse();
  };

  a.sortCustomLayers = A;
  /**
  * Fetch property values list
  * @param {String} layer Layer id to fetch
  * @param {Object} property Property to fetch
  * @return Mixed[]
  */

  var B =
  /*#__PURE__*/
  function () {
    var a = (0, d.default)(
    /*#__PURE__*/
    c.default.mark(function a(b, _ref20, e) {
      var d = _ref20.property;
      var f, h;
      return c.default.wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.next = 2, g.default.search({
                index: b,
                baseQuery: e,
                aggregations: [{
                  type: "terms",
                  field: "".concat(d, ".keyword"),
                  name: "values",
                  options: {
                    size: g.MAX_SIZE
                  }
                }],
                size: 0
              });

            case 2:
              return f = a.sent, h = f.aggregations.values.buckets, a.abrupt("return", h.map(function (_ref21) {
                var a = _ref21.key;
                return a;
              }));

            case 5:
            case "end":
              return a.stop();
          }
        }
      }, a);
    }));
    return function () {
      return a.apply(this, arguments);
    };
  }();
  /**
  * Fetch property's min and max values
  * @param {String} layer Layer id to fetch
  * @param {Object} property Property to fetch
  * @return { min: Number, max: Number }
  */


  a.fetchPropertyValues = B;

  var C =
  /*#__PURE__*/
  function () {
    var a = (0, d.default)(
    /*#__PURE__*/
    c.default.mark(function a(b, _ref22, e) {
      var d = _ref22.property;
      var f, h, i, j, k, l, m, n;
      return c.default.wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return a.next = 2, g.default.search({
                index: b,
                baseQuery: e,
                aggregations: [{
                  type: "max",
                  field: "".concat(d),
                  name: "max"
                }, {
                  type: "min",
                  field: "".concat(d),
                  name: "min"
                }],
                size: 0
              });

            case 2:
              return f = a.sent, h = f.aggregations, i = h.min, j = void 0 === i ? {} : i, k = j.value, l = h.max, m = void 0 === l ? {} : l, n = m.value, a.abrupt("return", {
                min: k && Math.round(k),
                max: n && Math.round(n)
              });

            case 5:
            case "end":
              return a.stop();
          }
        }
      }, a);
    }));
    return function () {
      return a.apply(this, arguments);
    };
  }();
  /**
  * Transform a layersTree into a flat array of layers
  */


  a.fetchPropertyRange = C;

  var D = function D(a) {
    var b = [];
    return a.forEach(function (a) {
      a.label && b.push(a), a.layers && b.push.apply(b, _toConsumableArray(D(a.layers)));
    }), b;
  },
      E = function E(a) {
    var c = D(a),
        d = c.reduce(function (_ref23, d) {
      var _ref23$beforeEach = _slicedToArray(_ref23.beforeEach, 1),
          c = _ref23$beforeEach[0],
          a = _ref23.slides;

      var e = d.label,
          f = d.content,
          g = void 0 === f ? "" : f,
          h = d.layers,
          i = void 0 === h ? [] : h,
          j = (0, b.default)(d, ["label", "content", "layers"]);
      return {
        beforeEach: [k({}, c, {
          layers: [].concat(_toConsumableArray(c.layers), _toConsumableArray(i.filter(function (a) {
            return "string" == typeof a;
          })))
        })],
        slides: [].concat(_toConsumableArray(a), [k({
          title: e,
          content: g,
          layouts: [{
            layers: i.filter(function (a) {
              return "string" == typeof a;
            }),
            active: !0
          }]
        }, j)])
      };
    }, {
      beforeEach: [{
        layers: [],
        active: !1
      }],
      slides: []
    });
    return d;
  };
  /**
  * Story type view needs a specfic format.
  */


  a.layersTreeToStory = E;
  a.default = {
    initLayersStateAction: q,
    setLayerStateAction: r,
    filterLayersFromLayersState: t,
    hasTable: u,
    hasWidget: v,
    filterFeatures: x,
    resetFilters: y,
    sortCustomLayers: A,
    fetchPropertyValues: B,
    fetchPropertyRange: C,
    layersTreeToStory: E
  };
});